import { useAccount } from "wagmi";

/**
 * Returns the currently connected wallet address (undefined when disconnected).
 * The wallet is connected through the RainbowKit modal, which drives wagmi, so wagmi's account is the single source.
 */
export function useActiveAddress() {
    const { address } = useAccount();
    return address ?? undefined;
}
